import styled from 'styled-components';
import { JobSectionRight } from './JobSectionRight';

export const FullWidthSectionRight = styled(JobSectionRight)`
  width: 100%;
`;
